import { Component } from 'react';
import { Modal } from "react-bootstrap";

import { Col, Row, Container } from "react-bootstrap";
import { CONSTANTS } from '../../config/Constants';

export default class OldVersionDialog extends Component {


    render() {
        return (
            <Modal show={this.props.visible} fullscreen={false} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Older Versions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="level-review-dialog">
                        <Container>
                            <Row>
                                <Col>
                                    <p className="mt-3">
                                        Want to use the app as it used to be? Older versions are available here for download. Please be aware
                                        that <strong>these versions are no longer supported!</strong> You are welcome to download them, but if you
                                        run into issues, please update to the latest version or use the web application.
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <ul>
                                        {[...CONSTANTS.OlderVersions].reverse().map(v => (
                                            <li key={`version[${v}]`}>
                                                <strong>{v}</strong>
                                                <ul>
                                                    {Object.keys(CONSTANTS.Binaries).map(binName => (
                                                        <li key={`binary-${binName}`}>
                                                            <a rel="noreferrer" href={`${CONSTANTS.BinariesUrl}${v}/${CONSTANTS.Binaries[binName]}`} target="_blank">{binName}</a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </li>
                                        ))}
                                    </ul>
                                </Col>
                            </Row>
                    </Container>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}